import {useList} from "@refinedev/core";
import IClient from "../interfaces/IClient";

export const CLIENTS_RESOURCE = "client"

/**
 * Retrieves the list of clients from the data provider.
 *
 * @returns {Object} An object containing the clients and loading status.
 * @property {Array.<IClient>} clients - The list of clients.
 * @property {boolean} isLoadingClients - A boolean indicating if the clients are currently being loaded.
 */
export function getClients() {
    const { data: dataClients, isLoading: isLoadingClients } = useList<IClient>({
        resource: CLIENTS_RESOURCE,
        meta: {
            resourceName:"clients",
        }
    });
    return { clients: dataClients?.data, isLoadingClients };
}
